import React from "react";
import styled from "styled-components";
import { Card, Empty, Progress, Space, Tag, Typography } from "antd";

const { Text } = Typography;

const WidgetCard = styled(Card)`
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  height: 100%;

  .ant-card-head-title {
    color: #005249;
    font-weight: 700;
  }
`;

const RouteList = styled.div`
  display: grid;
  gap: 12px;
`;

const RouteRow = styled.div`
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 12px;
`;

const RouteHeader = styled(Space)`
  width: 100%;
  justify-content: space-between;
  margin-bottom: 8px;
`;

const RouteProfitabilityWidget = ({ routeProfitability }) => {
  const routes = routeProfitability?.routes || [];

  if (!routes.length) {
    return (
      <WidgetCard title="Route Profitability">
        <Empty
          description="No route profitability data for the selected filters"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      </WidgetCard>
    );
  }

  const maxRevenue = Math.max(...routes.map((route) => route.revenueEstimate || 0), 1);

  return (
    <WidgetCard
      title="Route Profitability"
      extra={<Tag color="blue">{routes.length} routes</Tag>}
      data-testid="route-profitability-widget"
    >
      <RouteList>
        {routes.map((route) => (
          <RouteRow key={route.drilldownKey} data-drilldown-key={route.drilldownKey}>
            <RouteHeader>
              <Text strong>{route.label}</Text>
              <Text>{formatCurrency(route.revenueEstimate)}</Text>
            </RouteHeader>
            <Progress
              percent={Math.round((Number(route.revenueEstimate || 0) / maxRevenue) * 100)}
              showInfo={false}
              strokeColor="#005249"
            />
            <Space size={[6, 6]} wrap>
              <Tag>{route.tripCount} trips</Tag>
              <Tag>{route.orderCount} orders</Tag>
              {route.averageCapacityUsed != null && (
                <Tag>{route.averageCapacityUsed}% capacity</Tag>
              )}
              <Tag color="orange">Cost data incomplete</Tag>
            </Space>
          </RouteRow>
        ))}
      </RouteList>
      {routeProfitability.assumptions?.[0] && (
        <Text type="secondary">{routeProfitability.assumptions[0]}</Text>
      )}
    </WidgetCard>
  );
};

function formatCurrency(value) {
  return new Intl.NumberFormat("en-ZA", {
    style: "currency",
    currency: "ZAR",
    maximumFractionDigits: 0,
  }).format(Number(value || 0));
}

export default RouteProfitabilityWidget;
